// extracted by mini-css-extract-plugin
export var regular = "MoreSpeakersCard-module--regular--cbce6";
export var wide = "MoreSpeakersCard-module--wide--ee5d5";
export var title = "MoreSpeakersCard-module--title--4c1a5";
export var description = "MoreSpeakersCard-module--description--be702";